import ActionsForm from '@/shared/mixins/actionsForm'
import { toast } from '@/shared/utils/UIHelper'

export default {
  mixins: [ActionsForm],
  name: 'approvedisapprove',
  props: {
    selectedParcela: {
      type: Object,
      default: {}
    }
  },
  methods: {
    repprove () {
      this.page = false
      this.btnRepprove = false
      this.btnApprove = false
      this.btnSend = true
    },
    approve () {
      if (this.page) {
        this.$root.$emit('bv::hide::modal', 'modal-approve')
      }
      this.page = true
      this.btnRepprove = true
      this.btnSend = false
      toast.success('Solicitação de alteração de data de parcela aprovada com sucesso!')
    },

    close () {
      this.$root.$emit('bv::hide::modal', 'modal-approve')
    },

    sendrepproved () {
      this.$root.$emit('bv::hide::modal', 'modal-approve')
      toast.success('Solicitação de alteração de data de parcela reprovada com sucesso!')
    }
  },
  data () {
    return {
      page: true,
      btnRepprove: true,
      btnApprove: true,
      btnSend: false,
      btnClose: true,
      observacao: ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/changedateofinstallment/components/approvedisapprove/approvedisapprove.js